import { gql } from "@apollo/client";

export const GET_COMMODITY = gql`
  query commodity($id: String!) {
    commodity(id: $id) {
      id
      name
      createdAt
      createdBy
      measurementUnit
      categories
      imageURL
      status
      retail
      wholeSale
      retailPrices {
        id
        price
        latest
      }
      wholeSalePrices {
        id
        price
        latest
      }
    }
  }
`;
